import { render, staticRenderFns } from "./SaasAgreement.vue?vue&type=template&id=84f457d4&scoped=true"
import script from "./SaasAgreement.vue?vue&type=script&lang=js"
export * from "./SaasAgreement.vue?vue&type=script&lang=js"
import style0 from "./SaasAgreement.vue?vue&type=style&index=0&id=84f457d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f457d4",
  null
  
)

export default component.exports